import { render, staticRenderFns } from "./orderDetailOverview.vue?vue&type=template&id=4f915b85&scoped=true"
import script from "./orderDetailOverview.vue?vue&type=script&lang=js"
export * from "./orderDetailOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f915b85",
  null
  
)

export default component.exports